import {
  NotificationCentral,
  NotificationCentralResponse,
  NotificationCentralUnreadCountResponse,
} from '@types'
import { Service } from '@tino-frontend/adapters'

export const NOTIFICATION_DEFAULT_LIMIT = 10

export class NotificationCentralService {
  private path = '/v1/notifications'

  constructor(private readonly supplierBFF: Service) {}

  async notifications(
    user_id: string,
    limit: number = NOTIFICATION_DEFAULT_LIMIT,
    offset: number = 0
  ): Promise<NotificationCentralResponse> {
    try {
      const notifications: NotificationCentral[] = await this.supplierBFF.get(
        this.path,
        {
          params: { user_id, limit, offset },
        }
      )

      return { notifications }
    } catch (e) {
      return { notifications: [] } as NotificationCentralResponse
    }
  }

  async notificationsUnreadCount(
    user_id: string
  ): Promise<NotificationCentralUnreadCountResponse> {
    return await this.supplierBFF.get(`${this.path}/unread-count`, {
      params: { user_id },
    })
  }

  async readNotification(notificationId: string): Promise<void> {
    return await this.supplierBFF.patch(`${this.path}/${notificationId}/read`)
  }
}
